var map = {
	"./img-1.jpg": 6040,
	"./img-10.jpg": 2923,
	"./img-11.jpg": 6719,
	"./img-12.jpg": 1095,
	"./img-13.jpg": 4528,
	"./img-14.jpg": 2963,
	"./img-2.jpg": 7410,
	"./img-3.jpg": 1754,
	"./img-4.jpg": 4353,
	"./img-5.jpg": 7251,
	"./img-6.jpg": 7322,
	"./img-7.jpg": 6714,
	"./img-8.jpg": 2537,
	"./img-9.jpg": 2146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4793;